import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import { DataBlocks, Table, I18n } from 'components';
import { formatUnitString } from 'utils/formatString';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const formatBalance = (input) => {
  const array = input.split(' ');
  return formatUnitString(array[0], array[1] || 'RUR');
};

const formatDate = (input) => {
  if (!input) return '∞';
  const date = new Date(input);
  return date.toLocaleDateString('ru');
};

const Balances = ({ balanceAndBonuses, isFetching }) => {
  if (isFetching || !balanceAndBonuses) {
    return null;
  }

  return (
    <DataBlocks.ContentGroup
      title={<I18n path="detalization.balances.blockTitle" />}
    >
      {balanceAndBonuses.length ? (
        <Table
          data={balanceAndBonuses}
          config={{
            columns: [
              {
                name: 'Название',
                dataField: 'title',
              },
              {
                name: 'Было',
                dataField: 'startBalanceAmount',
                transformer: (row) => formatBalance(row.startBalanceAmount),
                hideOnMobile: true,
                width: '100px',
              },
              {
                name: 'Пополнения',
                dataField: 'addedBonuses',
                transformer: (row) => formatBalance(row.addedBonuses),
                hideOnMobile: true,
              },
              {
                name: 'Расходы',
                dataField: 'spentBonuses',
                transformer: (row) => formatBalance(row.spentBonuses),
                width: '100px',
              },
              {
                name: 'Осталось',
                dataField: 'endBalanceAmount',
                transformer: (row) => formatBalance(row.endBalanceAmount),
                width: '100px',
              },
              {
                name: 'Срок действия',
                dataField: 'expirationDate',
                transformer: (row) => formatDate(row.expirationDate),
                hideOnMobile: true,
              },
            ],
            uniqueIdField: 'title',
            nameAsTranslationKey: false,
          }}
        />
      ) : (
        <div className={cx('emptyMessage')}>
          <I18n path="detalization.balances.emptyMessage" />
        </div>
      )}
    </DataBlocks.ContentGroup>
  );
};

Balances.propTypes = {
  balanceAndBonuses: PropTypes.array,
  isFetching: PropTypes.bool,
};

function mapStateToProps(state) {
  return state.detalization.expenses;
}

export default connect(mapStateToProps)(Balances);
